import Styled from "styled-components";

export default Styled.p`
  font-size: 12px;
  margin: 0;
color: ${(props) => (props.color ? props.color : "#90a4ae")};`;
